/** How the agent bargains (ADR 0033): the owner's usual pace, chosen in Settings. */
export const bargain = {
    "bargain.label": "How your agent bargains, usually",
    "bargain.what": "Your agent opens and gives way a little differently on every job, so nobody can work out your limit. This sets its usual pace; it never goes past your limit.",
    "bargain.patient": "Patient",
    "bargain.steady": "Steady",
    "bargain.quick": "Quick",
};
//# sourceMappingURL=bargain.js.map